<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_edit_operation_title' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data.produit">
    <mat-form-field>
      <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
      <mat-select name="transportName" [value]="data?.produit.transportId || '0'" (selectionChange)="selectTransportChange($event.value)">
        <mat-option value="0">{{ 'common_no_transport' | translate }}</mat-option>
        <mat-option *ngFor="let t of data.transports" [value]="t.resourceId">{{ t?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.familyCode == FamilyCodes.RoadTransportCode">
      <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
      <mat-select name="energyName" [value]="data?.produit.energyId || '0'" (selectionChange)="selectEnergyChange($event.value)">
        <mat-option value="0">{{ 'common_no_energy' | translate }}</mat-option>
        <mat-option *ngFor="let e of data.energies" [value]="e.resourceId">{{ e?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.familyCode != FamilyCodes.RoadTransportCode && this.data.produit.transportRuade == true">
      <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
      <input matInput type="string" [(ngModel)]="data?.produit.energieDescription" name="energyName" readonly disabled />
    </mat-form-field>
    <mat-checkbox class="isDoubleFreight" *ngIf="data.familyCode == FamilyCodes.RoadTransportCode" [(ngModel)]="data?.produit.isDoubleFreight" name="isDoubleFreight">{{ 'common_double_freight' | translate }}</mat-checkbox>
    <mat-form-field>
      <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produit.distance" name="distance" min="0" cdkFocusInitial required />
      <mat-error *ngIf="!data?.produit.distance" [innerHTML]="'common_error_distance_required' | translate"></mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="data?.produit.pipeProduct">
      <mat-label>{{ 'dialog_edit_operation_production_site' | translate }}</mat-label>
      <input matInput type="string" [(ngModel)]="data?.produit.productionSite" name="pipeProductProductionSite" />
    </mat-form-field>

    <mat-form-field>
      <mat-label *ngIf="!data?.produit.cableProduct && !data?.produit.pipeProduct">{{ 'common_field_quantity' | translate }}</mat-label>
      <mat-label *ngIf="data?.produit.cableProduct || data?.produit.pipeProduct == 1">{{ 'dialog_edit_operation_ml_installed' | translate }}</mat-label>
      <mat-label *ngIf="data?.produit.pipeProduct == 2">{{ 'dialog_edit_operation_unit_installed' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produit.quantity" name="quantity" required />
      <mat-error *ngIf="!data?.produit.quantity" [innerHTML]="'common_error_quantity_required_alt' | translate"></mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="data?.produit.pipeProduct">
      <mat-label>{{ 'dialog_edit_operation_diameter' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produit.diameter" name="pipeProductDiameter" required />
      <mat-error *ngIf="!data?.produit.diameter" [innerHTML]="'common_error_diameter_required' | translate"></mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="data?.produit.pipeProduct">
      <mat-label *ngIf="data?.produit.pipeProduct == 1">{{ 'dialog_edit_operation_unit_weight_ml' | translate }}</mat-label>
      <mat-label *ngIf="data?.produit.pipeProduct == 2">{{ 'dialog_edit_operation_unit_weight_unit' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produit.unitWeight" name="pipeProductUnitWeight" required />
    </mat-form-field>

    <mat-form-field *ngIf="data?.produit.cableProduct">
      <mat-label>{{ 'dialog_edit_operation_cable_section' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produit.section" name="cableProductSection" required />
    </mat-form-field>
    <mat-form-field *ngIf="data?.produit.cableProduct">
      <mat-label>{{ 'dialog_edit_operation_nb_conductors' | translate }}</mat-label>
      <input matInput type="number" min="1" [(ngModel)]="data?.produit.nbConductors" name="cableProductNbConductors" required />
    </mat-form-field>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data.produit" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
